
export type EnrollCourse400Result = typeof EnrollCourse400Result[keyof typeof EnrollCourse400Result];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnrollCourse400Result = {
  failed: 'failed',
} as const;
